import React, { FC, useEffect, useRef } from 'react';
import { Background } from 'src/components';
import { Modal, MvpAppDesignModal } from './ModalContainer.styles';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { IModal } from './interfaces';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

export const ModalContainer: FC<IModal> = ({ children, ...rest }) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const isFromMvpApp = useUrlParameterCheck('/app');

  const Container = isFromMvpApp ? MvpAppDesignModal : Modal;

  useEffect(() => {
    const modalElement = modalRef.current;
    disableBodyScroll(modalElement);

    return () => enableBodyScroll(modalElement);
  }, []);

  return (
    <Background tabIndex={1} color="dark">
      <Container
        aria-live={'assertive'}
        role="alertdialog"
        tabIndex={1}
        ref={modalRef}
        {...rest}
      >
        {children}
      </Container>
    </Background>
  );
};
